import styled, {css} from 'styled-components';
import Utility from '../../../../../../util/utilityfunctions';

const withSubject = css`
	grid-template-rows: 2.4rem 2.4rem;
	grid-template-areas:
		'notificationTo sentBy from date time options chevron'
		'. subject subject subject subject . .';
`;

const withoutSubject = css`
	grid-template-rows: 2.4rem;
	grid-template-areas: 'notificationTo sentBy from date time options chevron';
`;

export default styled.div`
	position: relative;
	--icon-size: 2.4rem;

	&:last-of-type {
		border: none;
		&:after {
			content: none;
		}
	}

	--size: 0.8rem;
	--half-line: calc(2.4rem / 2);
	--half-size: calc(var(--size) / 2);
	--timeline-color: var(--teal-500);
	--extra: 0.2rem;
	--left: 2.8rem;
	--transform: calc(var(--size) * -1);

	--reg-col: calc(20% - var(--gap));
	--trigger-col: 2.4rem;

	padding-left: var(--left);
	&:before {
		content: '';
		position: absolute;
		background-color: var(--timeline-color);
		width: var(--size);
		height: var(--size);
		border-radius: 50%;
		top: calc(var(--gap) + var(--half-line) - var(--half-size) - var(--extra));
		left: var(--left);
		transform: translateX(var(--transform));
	}
	&:after {
		content: '';
		position: absolute;
		background-color: var(--timeline-color);
		width: 0.1rem;
		height: calc(100% + var(--extra));
		top: calc(var(--gap) + var(--half-line) - var(--half-size) - var(--extra));
		left: calc(var(--left) + var(--half-size));
		transform: translateX(var(--transform));
	}

	.header-container {
		display: grid;
		grid-template-columns: repeat(2, var(--reg-col)) calc(var(--reg-col) - var(--trigger-col)) calc(
				var(--reg-col) - var(--trigger-col)
			) calc(var(--reg-col) - var(--trigger-col)) var(--trigger-col) var(--trigger-col);
		${({isOpen}) => (isOpen ? withoutSubject : withSubject)};
		grid-gap: var(--gap);
		padding: var(--gap);
	}

	.content-flex {
		display: flex;
		gap: 0.5rem;
		align-items: center;
		overflow: hidden;
		span:last-child {
			flex: 1;
			span {
				display: block;
			}
		}
	}

	.notification-to {
		.notification-to-icon {
			display: flex;
		}
	}

	.chevron {
		grid-area: chevron;
	}

	.motif-accordion,
	.motif-accordion-content-visible:not(.motif-metadata) {
		background: transparent;
		border-width: 0;
	}

	&.msg-accordion-wrapper {
		.motif-accordion:hover {
			box-shadow: none;
		}
	}

	.motif-accordion-content {
		padding: 0 var(--gap);
	}
`;
